import dayjs from "dayjs";
import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
  ComposedChart,
  Bar,
  LineChart,
  ReferenceLine,
  Scatter,
  Cell,
} from "recharts";
import nodata from '../../src/assets/images/no-data.png'

export default class Example extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render() {
    const groupedLineData = {};

  Object.values(this.props.fuelGraphData || {})
    .flatMap((dayObj) => Object.values(dayObj))
    .forEach((item) => {

      const date = dayjs(item.date).format("MM-DD");

      if (!groupedLineData[date]) {
        groupedLineData[date] = {
          totalFuel: 0,
          count: 0,
        };
      }

      groupedLineData[date].totalFuel += parseFloat(item.fuel || 0);
      groupedLineData[date].count += 1;
    });

  const lineData = Object.keys(groupedLineData).map((date) => ({
    name: date,

    // Average fuel per day
    fuelLine:
      groupedLineData[date].totalFuel /
      groupedLineData[date].count,
  }));


  // ===== BAR DATA (Refill Fuel) =====
  const barData = Array.isArray(this.props.graphData)
    ? this.props.graphData.map((item) => ({
        name: dayjs(item.timestamp).format("MM-DD"),
        refillfuel: parseFloat(item.refillfuel || 0),
      }))
    : [];


  // ===== MERGE DATA =====
  const mergedData = lineData.map((lineItem) => {

    const refillItem = barData.find(
      (b) => b.name === lineItem.name
    );

    return {
      name: lineItem.name,

      fuelLine: Number(
        lineItem.fuelLine.toFixed(2)
      ),

      refillfuel: refillItem
        ? refillItem.refillfuel
        : 0,
    };
  });

    return (
      mergedData && mergedData.length > 0 ? (
        <ResponsiveContainer height={200}>
          <ComposedChart
            data={mergedData}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
            <Tooltip />

            <CartesianGrid stroke="#f5f5f5" />

            <XAxis dataKey="name" />

            <YAxis />

            <Bar
              dataKey="refillfuel"
              barSize={40}
              fill="green"
            />

            <Line
              type="monotone"
              dataKey="fuelLine"
              stroke="#8884d8"
              strokeWidth={3}
              dot={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
      ) : (
        <div
          style={{
            height: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={nodata}
            alt="No Data"
            style={{ width: 120, opacity: 0.7 }}
          />
          <p>No graph data available</p>
        </div>
      )

    );
  }
}
